<template id="combobox-template">
<div class="o-combobox">
    <input class="o-combobox__input"   v-model.trim="startemail" :disabled =disabled  v-on:click="showAutocompleteDropdown = true" @input="keyEvent($event)" @focus="checkEmail"  />
    <ul class="o-date-list" v-if="showAutocompleteDropdown">
      <li class="o-date-list__item" v-for="email in emailList" v-bind:key="email.id"  v-bind:id="email" v-on:click="select(email)" v-bind:class="{'o-date-list__item--selected': index == selectedIndex}">{{ email }}</li>
    </ul>
  </div>
</template>

<script>

export default {
name: 'combobox',
props: {
    emails : Array,
    modelValue :String,
    disabled : Boolean
},
data: function() {
    return {
      placeholder: "foo",
      email: "",
      showAutocompleteDropdown: false,
      index :0,
      startemail: this.modelValue,
      selectedIndex: 0,
      emailList :[]
    }
},
watch: {
  modelValue : {immediate:true, handler(newValue){this.startemail=newValue}}
},
created() {
    this.emailList = this.emails
},
computed: {
    filteredTimes() {
    return this.emails
    },
    
  },
  methods: {
  handleChange() {
    this.emailList = this.emails
    this.emailList = this.emailList.filter((email) =>  email.includes(this.startemail))
    },
    handleBackspace: function () {
        this.showAutocompleteDropdown = true;
    },
    select: function(email) {
      this.emailList = this.emails
        this.showAutocompleteDropdown = false;
      this.$emit('update:modelValue', email)
      
    },

    keyEvent() {
            this.emailList = this.emails
            
    this.emailList = this.emailList.filter((email) =>  email.toLowerCase().startsWith(this.startemail.toLowerCase()))
    if(this.startemail.length > 0 ) {
      
      this.$emit('update:modelValue', this.startemail)
    }
    },
    checkEmail(){
      this.emailList =this.startemail.toLowerCase().startsWith(this.startemail.toLowerCase());
      return this.emailList
    },
    setEmail(){
    this.emailList =this.startemail.toLowerCase().startsWith(this.startemail.toLowerCase());
      return this.emailList
    }
  }
}
</script>
<style scoped>


body {
  font-family: "Helvetica Neue";
  background: #fafafa;
  padding: 10rem;
}

@media (max-width: 480px) {
  body {
    padding: 0;
  }
}

.o-combobox {
width: 273px;
margin-top:10px;
height: 25px;

}

.o-combobox__input {
  width: 273px;
  height: 25px;
  position: relative;
}

.o-combobox__input:focus {
  box-shadow: none;
  -webkit-appearance: none;
  outline: 0;
}

.o-date-list {
  align-content: justify;

  background: white;
  border: 1px solid rgba(0, 0, 0, 0.08);
  padding: 0;
  height : auto;
  max-height : 100px;
  overflow-y: scroll;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  width: 273px;
}

.o-date-list__item {
  margin: 0;
  list-style-type: none;
  padding: 0.5rem;
  font-size: 14px;

  display: block;

  text-align: left;
  cursor: pointer;
  

}

.o-date-list__item:hover {
  opacity: 0.5;
}

.o-date-list__item--selected {
  background: rgba(0, 0, 0, 0.1);
}
</style>